import { render, staticRenderFns } from "./PageTwo.vue?vue&type=template&id=5d4603c3&scoped=true&"
import script from "./PageTwo.vue?vue&type=script&lang=ts&"
export * from "./PageTwo.vue?vue&type=script&lang=ts&"
import style0 from "./PageTwo.vue?vue&type=style&index=0&id=5d4603c3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4603c3",
  null
  
)

export default component.exports